import { all, takeLatest, put } from 'redux-saga/effects'
import { request } from '../../../../admincore'
import { searchAddressWithNo } from '../../api'
import { actions } from './actions'

function* LOAD({ payload }) {
  yield put(request(searchAddressWithNo(payload), actions.LOAD))
}

export default function* rootSaga() {
  yield all([takeLatest(actions.LOAD, LOAD)])
}
